// extracted by mini-css-extract-plugin
export default {"selectHolder":"pathnameMenu_selectHolder__Dha6t","container":"pathnameMenu_container__RzFW4","pathname":"pathnameMenu_pathname__vJbpl"};